
export default function(fields, fileUrl) {
  return {
    ...fields,
    fileUrl
  }
}

